// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import 'babel-polyfill';
import 'font-awesome/css/font-awesome.css';
import 'vuetify/dist/vuetify.css';

import Vue from 'vue';
import Vuetify from 'vuetify';
import unescape from 'lodash/unescape';
import * as Sentry from '@sentry/browser';

import Loader from '@/components/Loader';
import NoDataMessage from '@/components/shared/NoDataMessage';

import store from './store';
import router from './router';
import App from './App';

// setup sentry on production only
if (ENV === 'production') {
  Sentry.init({
    dsn: 'https://5e658ff54e554c01bc30932d79632e52@sentry.io/1301371',
    integrations: [new Sentry.Integrations.Vue({ Vue })],
  });
}


Vue.use(Vuetify);

Vue.component('loader', Loader);
Vue.component('no-data-message', NoDataMessage);


Vue.config.productionTip = false;

// TODO: move global declrations to their own file
// add scroll identification to the protype
Vue.prototype.$scrollPercent = function vueScrollPercent() {
  const scrollTop = document.documentElement.scrollTop;
  const windowHeight = window.innerHeight;
  const bodyHeight = document.body.offsetHeight - windowHeight;
  return (scrollTop / bodyHeight);
};

Vue.filter('unescape', value => unescape(value));

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js